import axiosInstance from "@/axios"

const editColumnSetting = (columnSettingId, columnSettingData) => {

    return axiosInstance.patch(`/api/profile/columnSettings/${columnSettingId}`, columnSettingData)
}

export {
    editColumnSetting,
}